// Configuration des prix Stripe pour différents environnements
const environment = process.env.REACT_APP_ENV || 'development';

// Structure des prix selon l'environnement
const priceConfigs = {
  development: {
    oneTime: [
      {
        id: 'price_1RIwzJPTuEnMEvGZHsep3Sb4', // Small package
        tokens: 40,
        price: 9,
        name: 'Pack débutant'
      },
      {
        id: 'price_1ROlUYPTuEnMEvGZvOTK4FbT', // Medium package
        tokens: 100,
        price: 19,
        name: 'Pack avancé'
      }
    ],
    subscription: {
      id: 'price_1RLr6kPTuEnMEvGZt3llsYtB',
      tokens: 100,
      price: 9,
      name: 'Abonnement Premium'
    }
  },
  production: {
    oneTime: [
      {
        id: 'price_1RPNTKPTuEnMEvGZQl34voK6',
        tokens: 10,
        price: 3,
        name: 'Pack 10 Credits'
      },
      {
        id: 'price_1RPNTTPTuEnMEvGZ6pzlGtps',
        tokens: 40,
        price: 9,
        name: 'Pack 40 Credits'
      },
      {
        id: 'price_1RPNTXPTuEnMEvGZdmIUONdc',
        tokens: 100,
        price: 19,
        name: 'Pack 100 Credits'
      },
      {
        id: 'price_1RPNTaPTuEnMEvGZif5i66OG',
        tokens: 200,
        price: 35,
        name: 'Pack 200 Credits'
      },
      {
        id: 'price_1RPNTcPTuEnMEvGZlVtVdmzQ',
        tokens: 500,
        price: 79,
        name: 'Pack 500 Credits'
      },
    ],
    subscription: {
      id: 'price_1RPNVdPTuEnMEvGZq3jkk5zI',
      tokens: 100,
      price: 9,
      name: 'AiVatar - Subscription'
    }
  }
};

// Exporter la configuration correspondant à l'environnement actuel
export const stripeConfig = priceConfigs[environment] || priceConfigs.development;

export default stripeConfig; 